import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth, isStaff } from "@/context/AuthContext";
import { useI18n } from "@/lib/i18n";

// Receives the JWT from the backend Google callback via the URL hash,
// stores it and redirects into the app.
export default function GoogleCallback() {
  const { loginWithToken } = useAuth();
  const { t } = useI18n();
  const nav = useNavigate();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace(/^#/, ""));
    const token = params.get("token");
    const next = params.get("next") || "";
    if (!token) {
      nav("/login?google_error=failed", { replace: true });
      return;
    }
    loginWithToken(token)
      .then((u) => {
        window.history.replaceState(null, "", window.location.pathname);
        toast.success(t("auth.googleSuccess"));
        nav(isStaff(u) ? "/admin" : (next || "/portal"), { replace: true });
      })
      .catch(() => nav("/login?google_error=failed", { replace: true }));
  }, []); // eslint-disable-line

  return (
    <div className="min-h-screen flex items-center justify-center text-muted-foreground" data-testid="google-callback">
      {t("common.loading")}
    </div>
  );
}
